module.exports = __webpack_public_path__ + "img/headerlogo.02cfc148.png";